import React from "react";
import "../CSS/Home.css";
import { Tab, Tabs } from "@mui/material";
// import TabContext from "@mui/lab/TabContext";
// import TabList from "@mui/lab/TabList";
// import TabPanel from "@mui/lab/TabPanel";
import Login from "./Auth/Login";
import Signup from "./Auth/Signup";
import DevModal from "./miscellaneous/DevModal";

const Home = () => {
  const [tabValue, setTabValue] = React.useState("Login");
  const [devModal, setDevModal] = React.useState(false);

  const tabChange = (event, clickedTab) => {
    setTabValue(clickedTab);
  };

  return (
    <>
      <div className="main_container">
        <div className="header_container">
          {/* <div className="header">
              Home
            </div> */}
          {/* <div className="developedByNadeemMansha">GupShup by Nadeem Mansha</div> */}
          <div className="chatAppNameConatiner">
            <div
              className="chatAppNameAtHome"
              onClick={() => setDevModal(true)}
            >
              GupShup
              <div>
                <p>by</p>
                <p>
                  <span>Nadeem</span> <span>Mansha</span>
                </p>
              </div>
            </div>
          </div>

          <div className="body">
            <div className="tabs_container">
              <Tabs
                value={tabValue}
                onChange={tabChange}
                textColor="inherit"
                TabIndicatorProps={{ style: { background: "#0dcaf0" } }}
              >
                <Tab value="Login" label="Login" className="tab"></Tab>
                <Tab value="Signup" label="Sign Up" className="tab"></Tab>
              </Tabs>
              {tabValue === "Login" ? <Login /> : null}
              {tabValue === "Signup" ? <Signup /> : null}
            </div>
          </div>
        </div>
        {/* <div className="body_container"></div> */}
      </div>
      {devModal ? (
        <DevModal devModal={devModal} setDevModal={setDevModal} start />
      ) : null}
    </>
  );
};

export default Home;
